import React from 'react';
import { connect } from 'react-redux';
import CompareProductBlock from '../Components/CompareProductBlock';
import { query, remove, removeAll } from '../Actions/ComparedProduct.action';

const CompareProductBlockContainer = (props) => {
  return (
    <CompareProductBlock
      comparedProducts={props.comparedProducts}
      linkToCompareProduct={props.linkToCompareProduct}
      onRemove={(ProductNumber) => props.remove(ProductNumber)}
      onRemoveAll={() => props.removeAll()}
    />
  );
};

const mapStateToProps = (state) => {
  return {
    comparedProducts: state.comparedProducts.list,
    errors: state.comparedProducts.errors,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getCompareProductList: () => dispatch(query()),
    remove: (ProductNumber) => dispatch(remove(ProductNumber)),
    removeAll: () => dispatch(removeAll()),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CompareProductBlockContainer);
